import { useMutation } from '@tanstack/react-query';

import { SalesPlanApi } from '../salesPlan.api';

export const useGetAllProductsCalculations = () => {
  return useMutation({
    mutationFn: SalesPlanApi.getAllProductsCalculations,
  });
};
